import styled from 'styled-components';

export const SelectContainer = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 100%;
  margin-top: 25px;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  @media screen and (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const SelectButton = styled.button<{ isOpen: boolean; isPlaceholder: boolean }>`
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  color: ${({ isPlaceholder }) => (isPlaceholder ? '#d6d6d6' : '#101010')};
  font-size: 14px;

  &:hover {
    border-color: #5768ff;
  }

  svg {
    transition: transform 0.2s;
    font-size: 12px;

    &.arrow {
      transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    }
  }
`;

export const OptionsList = styled.ul<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const OptionItem = styled.li<{ isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #101010;
  background-color: ${({ isSelected }) => (isSelected ? '#f0f2ff' : 'transparent')};

  &:hover {
    background-color: #f0f2ff;
  }
`;

export const SelectedContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;

  svg {
    font-size: 16px;
    color: #dedede;
  }
`;

export const SelectedLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: color 0.2s;

  &:hover {
    color: #5768ff;
  }

  &:focus {
    outline: none;
  }
`;
